export default "__VITE_ASSET__CPd9_k0r__"